import { put, takeEvery, call } from "redux-saga/effects"
import { authRequest } from "engine/modules/authRequest"
import env from "src/env"
import { READ_EVENT_AVAILABLE_RESOURCES_LIST } from "../actions/types"
import {
  readEventAvailableResourcesListSuccess,
  readEventAvailableResourcesListError,
} from "../actions/creators"

const { REACT_APP_API_URL } = env

// read list saga
function* requestRead(action) {
  const {
    config: { uuid, availableQuery },
  } = action
  try {
    const response = yield call(authRequest, {
      url: `${REACT_APP_API_URL}/events/${uuid}/resources/available`,
      method: `get`,
      params: {
        ...availableQuery,
      },
    })
    yield put(readEventAvailableResourcesListSuccess(action, response))
  } catch (error) {
    yield put(readEventAvailableResourcesListError(action, error))
  }
}

export default function* readSaga() {
  yield takeEvery(READ_EVENT_AVAILABLE_RESOURCES_LIST, requestRead)
}
